module.exports = __webpack_public_path__ + "img/1492938466.608966b2.jpg";